module.exports = __webpack_public_path__ + "static/front-1c38657093fe79b6cedfb14e7023bcc3.png";